// extracted by mini-css-extract-plugin
export default {"content":"Search_content__DFslV","card_search":"Search_card_search__TNWAh"};